export const SECTION_EXIT_SECONDS = 0.5;

export const BACKDROP_FADE_IN_SECONDS = 1.2;

export const SECTION_ATMOSPHERE_FADE_OUT_SECONDS = 0.3;

export const SECTION_FADE_SECONDS = 0.5;

export const BLACK_COVER_FADE_SECONDS = 0.45;
export const BLACK_STAGE_FADE_SECONDS = 0.8;

export const STORY_CLIPS_DELAY_SECONDS = 0.6;

// The Intro sparks' playback rate. Scales the lightning's whole clock --
// reveal, flicker and keyframes alike -- so every strike hits harder and
// comes round sooner without re-authoring any group.
export const INTRO_LIGHTNING_SPEED = 1.5;

// The longest a slide waiting on its clip may sit behind black. After it
// the clip's cover image shows instead -- under the translucent loading
// veil while the clip is still on its way. Also the grace before that
// veil appears at all, so a clip that starts promptly never flashes it.
export const VIDEO_COVER_FALLBACK_SECONDS = 1;

// How long a `full` visit may sit without its clip starting before the
// slide gives up on it and jumps to its `final` beat. A clip that never
// loads -- and never errors either, e.g. a stalled CDN response -- would
// otherwise hold the scroll lock until the stepper's own safety timeout.
export const SECTION_VIDEO_LOAD_TIMEOUT_SECONDS = 5.5;
